import React, { useEffect } from 'react';
import { useLingui } from '@lingui/react/macro';
import styled, { useTheme } from 'styled-components';

import { ZIndex } from '@rover/constants/src/styles/ZIndex';
import Close from '@rover/icons/svg/close.svg';
import { Box, Button } from '@rover/kibble/core';

export type BottomSheetProps = {
  children: React.ReactNode | React.ReactNode[];
  reference: React.RefObject<HTMLDivElement | null>;
  fullHeight?: boolean;
  onClose: () => void;
};

export const getButtonStyle = (theme: any): React.CSSProperties => ({
  border: 0,
  display: 'flex',
  padding: 0,
  position: 'absolute',
  right: theme.space['4x'],
  top: theme.space['4x'],
  zIndex: ZIndex.MODAL.toNumber(),
});

export const StyledCloseIcon = styled(Close)`
  height: ${({ theme }) => theme.space['4x']};
  width: ${({ theme }) => theme.space['4x']};
  fill: ${({ theme }) => theme.textColor.tertiary};
  pointer-events: none;
`;

const CalendarBottomSheet = ({
  children,
  reference,
  fullHeight,
  onClose,
}: BottomSheetProps): JSX.Element => {
  const { t } = useLingui();
  const theme = useTheme();
  const buttonStyle = getButtonStyle(theme);

  useEffect(() => {
    document.body.style.overflowY = 'hidden';

    return () => {
      document.body.style.overflowY = 'scroll';
    };
  });
  return (
    <Box
      borderTopLeftRadius={fullHeight ? '0px' : theme.space['4x']}
      borderTopRightRadius={fullHeight ? '0px' : theme.space['4x']}
      paddingBottom="12x"
      sx={{ backgroundColor: theme.colors.neutral.white, overflow: 'scroll' }}
      zIndex="20"
      maxWidth="100%"
      maxHeight={fullHeight ? '100vh' : '80vh'}
      height={fullHeight ? '100%' : undefined}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      ref={reference}
    >
      {fullHeight && (
        <Button onClick={onClose} aria-label={t`Close`} sx={buttonStyle}>
          <StyledCloseIcon />
        </Button>
      )}
      {children}
    </Box>
  );
};

export default CalendarBottomSheet;
